import { render, staticRenderFns } from "./SysAdminDashboard.vue?vue&type=template&id=48d5ffdc&scoped=true"
import script from "./SysAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SysAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./SysAdminDashboard.vue?vue&type=style&index=0&id=48d5ffdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5ffdc",
  null
  
)

export default component.exports